import {
  Box,
  Button,
  GridContainerWithTitle,
  HorizontalDivider,
} from '@ttx/design-system';
import {ButtonStyleType} from '@ttx/design-system/src/button/types';
import React from 'react';

export const BasicTitleButtonModal: React.FC<{
  children: React.ReactNode;
  title: string;
  onClose: () => void;
  onPressButton: () => void;
  buttonCta: string;
  buttonType: ButtonStyleType;
}> = ({children, title, onClose, onPressButton, buttonType, buttonCta}) => {
  return (
    <GridContainerWithTitle title={title} onModalClose={onClose}>
      <Box padding="lg">
        <>{children}</>
      </Box>
      <HorizontalDivider />
      <Button type={buttonType} onPress={onPressButton} hasBorder={false}>
        {buttonCta}
      </Button>
    </GridContainerWithTitle>
  );
};
